import { z } from 'zod';

export const naoAbateFormSchema = z.object({
  unidade_id: z.string().min(1, 'Selecione a unidade'),
  justificativa: z
    .string()
    .trim()
    .min(1, 'Informe a justificativa')
    .max(500, 'Máximo de 500 caracteres'),
});

export type TNaoAbateFormData = z.infer<typeof naoAbateFormSchema>;
